import React from "react";
import { useCart } from "@/context/CartContext";
import { Link } from "react-router-dom";
import ProductCard from "@/components/ProductCard";
import { Heart } from "lucide-react";

export default function Wishlist() {
  const { wishlist } = useCart();

  if (!wishlist.length) {
    return (
      <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="wishlist-empty">
        <Heart size={48} className="mx-auto text-black/30 mb-6" />
        <h1 className="font-display text-5xl tracking-tighter mb-4">WISHLIST IS EMPTY</h1>
        <p className="text-black/50 mb-8">Heart products you love. We'll save them here.</p>
        <Link to="/shop/all" className="inline-block bg-black text-white px-8 py-4 font-display tracking-widest text-sm">DISCOVER</Link>
      </div>
    );
  }

  return (
    <div className="max-w-[1600px] mx-auto px-6 lg:px-10 py-12" data-testid="wishlist-page">
      <h1 className="font-display text-6xl tracking-tighter mb-10">WISHLIST ({wishlist.length})</h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {wishlist.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
      </div>
    </div>
  );
}
